<template>
  <div>
    <the-welfare-part
      v-for="(el, index) in part"
      :key="index"
      :data="part[index]"
      :active="partActive"
      @tap="handleTap"
    />
  </div>
</template>

<script>
import TheWelfarePart from './TheWelfarePart'

export default {
  components: { TheWelfarePart },
  data() {
    return {
      part: [
        {
          id: 1,
          title: '薪酬福利',
          content: [
            {
              icon_row: 1,
              icon_col: 1,
              title: '六险一金	',
              desc: '入职当月即缴六险一金，助你在厦门安家一臂之力',
            },
            {
              icon_row: 1,
              icon_col: 2,
              title: '固定13薪',
              desc: '可以决定银行卡正负数的筹码，回家过年倍有面儿',
            },
            {
              icon_row: 1,
              icon_col: 3,
              title: '年终奖',
              desc: '妈妈再也不用担心我没有压岁钱了',
            },
            {
              icon_row: 1,
              icon_col: 4,
              title: '分红激励',
              desc: '多劳多得，勤劳致富不可或缺的好途径',
            },
          ],
        },
        {
          id: 2,
          title: '假期福利',
          content: [
            {
              icon_row: 2,
              icon_col: 1,
              title: '超长年假',
              desc:
                '最高累计30天，工作生活两不误，世界如此美妙，值得大家出门看看',
            },
            {
              icon_row: 2,
              icon_col: 2,
              title: '节日礼金',
              desc: '节日宠你没商量，让你的节日仪式感满满',
            },
            {
              icon_row: 2,
              icon_col: 3,
              title: '节日活动',
              desc: '不论单身派还是虐汪派，坚决不让你一个人',
            },
            {
              icon_row: 2,
              icon_col: 4,
              title: '女生姨妈假',
              desc: '特殊时期，给你妈妈般的呵护',
            },
          ],
        },
        {
          id: 3,
          title: '生活福利',
          content: [
            {
              icon_row: 4,
              icon_col: 1,
              title: '年度体检',
              desc:
                '你的健康格外珍贵，每年甄选专业机构，家属享受同等企业折扣，给你最专业的保障',
            },
            {
              icon_row: 4,
              icon_col: 2,
              title: '各类俱乐部	',
              desc: '即使告别校园，也要给你大学生活的体验',
            },
            {
              icon_row: 3,
              icon_col: 2,
              title: '下午茶',
              desc: '每周不重样，冬暖夏凉如你所想，给你“极致养猪”般体验',
            },
            {
              icon_row: 3,
              icon_col: 4,
              title: '家属观影',
              desc:
                '每个月120分钟的电影，解决时间紧张没办法陪家人、约朋友的难题',
            },
          ],
        },
      ],
      partActive: [],
    }
  },
  methods: {
    handleTap(data) {
      this.partActive = data
    },
  },
}
</script>
